/**
 * Copyright (c) 2026, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { PAGING_ITEMS_PER_PAGE } from "app/app-constants";
import { PagedResults } from "app/models/paged-results";
import { Zaa_ZonesResponseDto } from "app/models/zoneassignedassets/Zaa_ZonesResponeDto";
import { ZoneAssignedAssetsService } from "app/services/zone-assigned-assets.service";

/**
 * Resolver used to grab the first page of data for the Zone Assigned Assets 
 * in the background before the page loads. 
 */
@Injectable()
export class ZoneAssignedAssets_ZonesResponeDtoResolver implements Resolve<PagedResults<Zaa_ZonesResponseDto>> {

    /** Constructor */
    constructor(
        private zaaService: ZoneAssignedAssetsService
    ) { }
    
    /**
     * Obtains the first page of data while the route is being resolved. 
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<Zaa_ZonesResponseDto>> {
        // Get the number of Zones to query for
        let numberOfZones: number = route.data['zonesPerPage'];
        if (numberOfZones == null || numberOfZones < 1) {
            numberOfZones = PAGING_ITEMS_PER_PAGE;
        }

        // Call the API and return the result
        return this.zaaService.getZonesWithAssetCount(0, numberOfZones);
    }

}